import axios from "axios";
import produce from 'immer';
import { GET_ALERT } from './type';

type InitialState = {
    alerts: { uuid: string, name: string }[]
}

const initialState: InitialState = {
    alerts: []

}
function alertReducer(
    state = initialState,
    action: any,
): InitialState {
    switch (action.type) {
        case GET_ALERT:
            return produce(state, (draft) => {
                draft.alerts = action.payload
            })
        default:
            return state;
    }
}

export default alertReducer;